<template>
    <section class="ui-section p0">
        <div class="container iwd-responsive-layout">
            <div class="iwd-child-block tight iwd-flip-padded-200-300 skills-lab-builder-chapter-list">

                <div class="chapter-list-inner-panel" :style="{top: chapter_list_offset_top + 'px'}">
                    <div class="flex-title">
                        <h2 class="standard-title"></h2>
                        <small id="builder-info-toggle" @click="showInfoModal()"></small>
                    </div>

                    <div id="chapter-list-head">
                        <span></span>
                        <span>Chapter</span>
                        <span>Exercise</span>
                        <span></span>
                    </div>

                    <ul>

                        <li v-for="(video, index) in user_data.selected_videos" :class="{'ignore': !video.active}">
                            <span>{{ index+1 }}</span>
                            <span>{{ video.chapter_title }}</span>
                            <span>{{ video.title }}
                                <img :src="'/build/assets/' + video.image.replace('{size}', '185').replace('.png', '.jpg')" :alt="video.title">
                            </span>
                            <div>
                                <button
                                    :class="{ disabled: false }"
                                    @click="toggleIgnoreChapter((video.chapter_id), (video.order-1), video.active)">
                                </button>
                                <button
                                    :class="{ disabled: (video.order === chapters[getChapterIndexFromId(video.chapter_id)].videos.length) }"
                                    @click="levelUp((video.chapter_id), (video.order-1), video.active)">
                                </button>
                                <button
                                    :class="{ disabled: video.order === 1 }"
                                    @click="levelDown((video.chapter_id), (video.order-1), video.active)">
                                </button>
                            </div>
                        </li>

                    </ul>
                </div>

            </div>

            <div class="iwd-child-block iwd-span-36 iwd-flip-padded-200-300 skills-lab-builder-overview">
                <div class="flex-title">
                    <h2 class="standard-title">The Moves</h2>
                </div>

                    <section v-if="full_sequence !== null" v-for="(day, index) in full_sequence">
                        <h1>Cycle {{ index + 1 }}</h1>
                        <ul>
                           <li v-for="vid in day">{{ vid.title }}</li>
                        </ul>
                    </section>
                    <section v-if="full_sequence === null">
                        <p>No chapters selected.</p>
                    </section>

            </div>

        </div>

        <div class="modal-content-store">

            <h1 class="mb150">It's time to customise your book moves!</h1>

            <h2 class="mb150">You can use this page to change the intensity of the exercises in all 9 chapters of the book and to hide chapters you&rsquo;d prefer not to work on.</h2>

            <ul class="standard mb2">
                <li>Change the intensity of exercises as you improve</li>
                <li>Level up or down per chapter</li>
                <li>Hide chapters that you prefer not to work on</li>
                <li>View all of your upcoming cycles</li>
                <li>Browse the chapters on the page &lsquo;<a href="/chapters">browse the chapters</a>&rsquo;</li>
            </ul>

            <p><small>Having problems? Check out our <a href="/info/support">support page</a> for tips and video tutorials.</small></p>

        </div>

    </section>
</template>

<script>

    var emitter = require('tiny-emitter/instance');

    export default {
    	data(){
    		return {
    			chapter_list_el: null,
                chapter_list_offset_top: 0
            }
        },
        mounted()
        {
    		this.chapter_list_el = $('.chapter-list-inner-panel');

            this.getUserData(['chapters']).then(()=>{
            	// this.fixChaptersToScroll();
              this.getChapterIndexFromId(4);
            });
            // emitter.on('windowResized', ()=>{
            // 	this.fixChaptersToScroll();
            // });
        },
        methods: {
        getChapterIndexFromId(id)
        {
            return this.chapters.findIndex((chapter) => chapter.id === id);
        },
    		fixChaptersToScroll(){
                if(this.$store.getters.isDesktopScreen)
                {
                    const el_offset_top = this.chapter_list_el.offset().top;
                    const el_height     = this.chapter_list_el.height();
                    const doc_height    = $(document).height();
                    const footer_height = $('#app>footer').height();

                    const self = this;

                    $(window).on('scroll', function(e)
                    {
                        const window_scroll_from_top = $(this).scrollTop();

                        if((window_scroll_from_top >= el_offset_top) && !((window_scroll_from_top + el_height) >= doc_height - footer_height - 10))
                        {
                            self.chapter_list_offset_top = window_scroll_from_top - el_offset_top;
                        }
                    });
                }else{
                	this.chapter_list_offset_top = 0;
                	$(window).off('scroll');
                }
            },
            levelUp(chapter_id, current_video_index, is_active)
            {
              const chapter_index = this.getChapterIndexFromId(chapter_id);

            	if(current_video_index === this.chapters[chapter_index].videos.length) return false;

            	this.chapters[chapter_index].videos[current_video_index+1].active = is_active;

	            this.user_data.selected_videos[chapter_index] = this.chapters[chapter_index].videos[current_video_index+1];

	            // const chapter_id = this.chapters[chapter_index].videos[current_video_index+1].chapter_id;
	            const video_id     = this.chapters[chapter_index].videos[current_video_index+1].id;
	            this.saveDrill(chapter_id, video_id, is_active);
            },
            levelDown(chapter_id, current_video_index, is_active)
            {
              const chapter_index = this.getChapterIndexFromId(chapter_id);

            	if(current_video_index === 0) return false;

            	this.chapters[chapter_index].videos[current_video_index-1].active = is_active;

                this.user_data.selected_videos[chapter_index] = this.chapters[chapter_index].videos[current_video_index-1];

	            // const chapter_id = this.chapters[chapter_index].videos[current_video_index-1].chapter_id;
	            const video_id     = this.chapters[chapter_index].videos[current_video_index-1].id;
	            this.saveDrill(chapter_id, video_id, is_active);
            },
            toggleIgnoreChapter(chapter_id, current_video_index, is_active)
            {
              const chapter_index = this.getChapterIndexFromId(chapter_id);

    			this.chapters[chapter_index].videos[current_video_index].active = !is_active;

    			this.user_data.selected_videos[chapter_index] = this.chapters[chapter_index].videos[current_video_index];

	            // const chapter_id = this.chapters[chapter_index].videos[current_video_index].chapter_id;
	            const video_id     = this.chapters[chapter_index].videos[current_video_index].id;
	            this.saveDrill(chapter_id, video_id, !is_active);
            },
            saveDrill(chapter_id, video_id, is_active)
            {
                axios.post('/api/user/save-drill', {chapter_id: chapter_id, video_id: video_id, active: is_active}).then((response)=>{
                    // console.log(response.data.message);
                });
            },
            showInfoModal(){
                const media = {
                	display: false,
                    img_src: null
                };
                const content = $('.modal-content-store').html();
                emitter.emit('showModal', {media, content});
                // EventBus.$emit('showModal', {media, content})
            }
        }
    }

</script>
